<template>
  <div class="gift_box">
    <template v-if="giftType == 1">
      <img src="../../assets/images/main/gift1.jpg" alt="">
    </template>
    <template v-else-if="giftType == 2">
      <img src="../../assets/images/main/gift2.jpg" alt="">
    </template>
    <template v-else>
      <img src="../../assets/images/main/gift3.jpg" alt="">
    </template>
  </div>
</template>
<script>
export default {
  data() {
    return {
      giftType:　1
    }
  },
  created() {
    this.giftType = this.$route.query.type
  }
}
</script>

<style lang="scss">
.gift_box {
  width: 750px;
  margin: 0 auto;
  img {
    width: 100%;
    height: auto;
  }
}
</style>